export const isDefined = <T>(value: T | undefined): value is T => Boolean(value);
